import { Controller } from '@hotwired/stimulus'
import { Toast } from 'bootstrap'

export default class extends Controller {
  connect(): void {
    this.#showExistingToasts()
    this.#listenForAddedToasts()
    document.addEventListener('turbo:morph', this.#showExistingToasts)
  }

  disconnect(): void {
    document.removeEventListener('turbo:morph', this.#showExistingToasts)
  }

  // A morph reuses the existing toast nodes, so nothing is added and Stimulus never reconnects.
  // Idiomorph syncs the incoming `class="toast"` onto them, dropping the `show` Bootstrap needs to
  // make them visible, so every toast has to be shown again once the morph is done.
  #showExistingToasts = () => {
    this.element.querySelectorAll('.toast').forEach((toast) => {
      Toast.getOrCreateInstance(toast as HTMLElement).show()
    })
  }

  #listenForAddedToasts() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement && node.classList.contains('toast')) {
            Toast.getOrCreateInstance(node).show()
          }
        })
      })
    })

    observer.observe(this.element, { childList: true })
  }
}
